import styles from './styles.module.scss';

export default function Separator() {
  return <div className={styles.separator} />;
}
